/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,
    Modal} from "reactstrap";
// core components
import GeneralHeader from "components/Headers/GeneralHeader.js";
import axios from 'axios';
import {connect} from "react-redux";
import UsersTable from 'views/scripts/tables/UsersTable.js';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const mapStateToProps = state => ({users: state.users,refresh_users:state.refresh_users});

class AddMarker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            surname: '',
            email:'',                
            contact_number:'',
            users: [],
            modalIsOpen: false,
            refresh_users: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.showAddMarkerDialog = this.showAddMarkerDialog.bind(this);
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.toggle = this.toggle.bind(this);
        this.saveMarker = this.saveMarker.bind(this);
    }

    componentDidMount() {
        //console.log('props', this.props);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({[name]: value});
    }

    saveMarker(){        
        let user ={'name':this.state.name,'surname':this.state.surname,'email':this.state.email,'contact_number':this.state.contact_number};
        //console.log('saving user',user);
        let cur = this;

        axios({
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'post',
            url: 'https://markerportalbackend.thinkdigitalacademy.org/api/add-marker',
            data: user
        }).then(res => {
            //console.log(res);
            //console.log(res.data);
            //console.log('saving user', res.data);
            cur.setState({modalIsOpen: false,refresh_users:true,name:'',surname:'','email':'',contact_number:''});
           
            toast(res.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.SUCCESS
            });

        }).catch(error => {
            let error_result = error.response;
            //console.log(error_result);
            toast('Error occurred. ' + error_result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }

    showAddMarkerDialog() {
        this.setState({modalIsOpen: true});
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    afterOpenModal() { // references are now sync'd and can be accessed.
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    toggle() {
        this.setState({
            modalIsOpen: !this.state.modalIsOpen
        });
    }

    render() {
        return (
            <>
            <ToastContainer position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover/>
                <ToastContainer/>
                <GeneralHeader/>
                <Container className="mt--7" fluid>
                    <Row>

                        <Col className="order-xl-1" xl="12">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        {
                                            localStorage.getItem('userRole','app-admin')&& <Col xs="8">
                                            <Button size="sm" color="success" type="button"
                                                onClick={
                                                    this.showAddMarkerDialog
                                            }>
                                                Add Marker
                                            </Button>
                                        </Col>
                                        }
                                       
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Form>
                                        <div className="pl-lg-4">
                                            <Row>
                                                <Col lg={12}>
                                                    <UsersTable/>
                                                </Col>
                                            </Row>

                                        </div>
                                        <hr className="my-4"/>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        <Modal className="modal-dialog-centered"
                            isOpen={
                                this.state.modalIsOpen
                            }
                            toggle={
                                this.toggle
                            }
                            size='lg'>
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Add User
                                </h5>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button"
                                    onClick={
                                        this.toggle
                                }>
                                    <span aria-hidden={true}>×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <Form>
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-first-name">
                                                    First name
                                                </label>
                                                <Input name="name" className="form-control-alternative"
                                                    value={
                                                        this.state.name
                                                    }
                                                    id="input-first-name"
                                                    placeholder="First name"
                                                    type="text"
                                                    onChange={
                                                        this.handleChange
                                                    }/>
                                            </FormGroup>
                                        </Col>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-last-name">
                                                    Last name
                                                </label>
                                                <Input name="surname"
                                                    value={
                                                        this.state.surname
                                                    }
                                                    className="form-control-alternative"
                                                    id="input-last-name"
                                                    placeholder="Last name"
                                                    type="text"
                                                    onChange={
                                                        this.handleChange
                                                    }/>
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-email">
                                                    Email Address
                                                </label>
                                                <Input name="email" className="form-control-alternative"
                                                    value={
                                                        this.state.email
                                                    }
                                                    id="input-email"
                                                    placeholder="Email Address"
                                                    type="email"
                                                    onChange={
                                                        this.handleChange
                                                    }/>
                                            </FormGroup>
                                        </Col>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-contact-number">
                                                    Contact Number
                                                </label>
                                                <Input name="contact_number"
                                                    value={
                                                        this.state.contact_number
                                                    }
                                                    className="form-control-alternative"
                                                    id="input-contact-number"
                                                    placeholder="Contact Number"
                                                    type="tel"
                                                    onChange={
                                                        this.handleChange
                                                    }/>
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                </Form>

                            </div>
                            <div className="modal-footer">                               
                                <Button onClick={this.saveMarker} size="sm" color="success" type="button">
                                    Save Marker
                                </Button>
                            </div>
                        </Modal>
                    </Row>
                </Container>
            </>
        );
    }
}
export default connect(mapStateToProps)(AddMarker);
